<template>
  <el-dialog top="5vh" title="" :visible.sync="visible" class="first-gift-dialog" :close-on-click-modal="false">
    <div class="lottery-win">
      <div class="a">恭喜您抽中啦！</div>
      <div class="b">
        <img :src="reward.award_pic" alt="" />
      </div>
      <div class="c">{{ reward.lott_num + reward.name }}</div>
      <div class="d">可在中奖记录内进行查看</div>
      <div class="btn" @click="visible = false">继续夺宝</div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  props: {
    reward: {
      type: Object,
    },
  },
  watch: {},

  data() {
    return {
      visible: false,
    };
  },
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    open() {
      this.visible = true;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    // height: 5.74rem;
  }
  .el-dialog {
    width: 6.45rem !important;
    // width: 3.55rem;
    // height: 1.96rem;
    border-radius: 0.1rem;
  }
}
.lottery-win {
  width: 6.45rem;
  height: 6.7rem;
  background: url("~@/assets/img/dialog/lottery-win-bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  color: #ffdfbd;
  .a {
    font-size: 0.3rem;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 0.2rem;
  }
  .b {
    margin-bottom: 0.15rem;
    width: 2.2rem;
    height: 1.05rem;
    background: url("~@/assets/img/dialog/award-bg.png") no-repeat;
    background-size: 100% 100%;
    img {
      height: 0.65rem;
    }
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .c {
    font-size: 0.24rem;
    margin-bottom: 0.05rem;
  }
  .d {
    font-size: 0.18rem;
    margin-bottom: 0.15rem;
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.97rem;
    height: 0.62rem;
    background: linear-gradient(136.27deg, #ffd600 20%, #ff8f00 95.56%);
    box-shadow: 0px 2.18426px 0px #d83828, inset 0px 5.8247px 5.8247px rgba(255, 0, 0, 0.25), inset 0px 0px 17.4741px rgba(0, 0, 0, 0.25);
    border-radius: 0.62rem;
    position: absolute;
    bottom: -1.08rem;
    color: #861700;
    font-size: 0.24rem;
    font-weight: 600;
    cursor: pointer;
  }
}
</style>
